import cplook from 'cplook'
import moment from 'moment'
snackbar = require('./snackbar.coffee')
elm = require('../../../../elm/elm.js')
scheduled_email = require('../scheduled_email.coffee')

retry = (target, func)->
  return false if $(target).length > 0
  window.requestAnimationFrame(func)
  true

handleCallbacks = (cmd)->
  cbname = "#{cmd}_callback"
  info = $('#email_form_component').data(cbname)
  if info?
    $('#email_form_component').data(cbname, null)
    $.ajax
      url: info.url
      type: info.method

handleSetBody = (bodyContent)->
  return if retry '#email_component_body', ->
    handleSetBody(bodyContent)

  if cplook.editor.tinymce_ready('email_component_body')
    cplook.editor.tinymce_set_content('email_component_body', bodyContent)
  else
    cplook.editor.tinymce_enable($('#email_component_body'), $('#email_form_component'))
    cplook.editor.tinymce_set_content('email_component_body', bodyContent)

    if $('#email_date_input').length > 0
      $('#email_date_input').each cplook.datepicker.launch_datepicker
      $('#email_start_time_input').each cplook.datepicker.launch_timepicker
      $('#email_start_time_input').on 'dp.change', ->
        startTime = scheduled_email.getTimeValue('email_start_time_input')
        $('#email_end_time_input').data('DateTimePicker').date(
          moment(startTime, 'HH:mm a').add(30, 'm')
        )
      $('#email_end_time_input').each cplook.datepicker.launch_timepicker
      defStart = moment().add(1, 'd').hour(10).minute(0)
      $('#email_date_input').data('DateTimePicker').date(defStart)
      $('#email_start_time_input').data('DateTimePicker').date(defStart)
      $('#email_end_time_input').data('DateTimePicker').date(defStart.add(30, 'm'))

handleSetFields = (json)->
  return if retry '#email_schedule_date_input', ->
    handleSetFields(json)
  fields = JSON.parse(json)
  if $('#email_date_input').length > 0
    if $('#email_date_input').data('DateTimePicker')?
      $('#email_date_input').data('DateTimePicker').date(moment.parseZone(fields.startTime))
      $('#email_start_time_input').data('DateTimePicker').date(moment.parseZone(fields.startTime))
      $('#email_end_time_input').data('DateTimePicker').date(moment.parseZone(fields.endTime))
    else
      setTimeout ->
        handleSetFields(json)
      , 10
      return

  $('#email_schedule_date_input').data('DateTimePicker').date(moment(fields.scheduleDate))
  $('#email_schedule_time_input').data('DateTimePicker').date(
    moment(fields.scheduleTime, 'HH:mm a')
  )

handleSendFields = (app)->
  settings = $('#email_component_body').data('tmcesettingskey')
  if settings == 'email'
    body = tinyMCE.EditorManager.get('email_component_body').getContent()
  else if settings == 'sms'
    body = tinyMCE.EditorManager.get('email_component_body').getContent({ format: 'text' })
  else
    body = ''

  app.ports.emailFields.send
    body: body
    date: scheduled_email.getDateValue('email_date_input')
    startTime: scheduled_email.getTimeValue('email_start_time_input')
    endTime: scheduled_email.getTimeValue('email_end_time_input')
    scheduleDate: scheduled_email.getDateValue('email_schedule_date_input')
    scheduleTime: scheduled_email.getTimeValue('email_schedule_time_input')

handleClearEditor = (app, val)->
  cplook.editor.tinymce_disable($('#email_component_body'), $('#email_form_component'))
  handleDone(app, val)
  if $('#email_form_component').data('flags').embedded
    setTimeout ->
      $("##{$('#email_form_component').data('origin')}").click()
    , 10

handleResetEditor = (app, val)->
  cplook.editor.tinymce_disable($('#email_component_body'), $('#email_form_component'))
  app.ports.emailMsg.send(["EditorReset", val])


handleScheduleEnabled = (app)->
  return if retry '#email_schedule_date_input', ->
    handleScheduleEnabled(app)
  $('#email_schedule_date_input').each cplook.datepicker.launch_datepicker
  $('#email_schedule_time_input').each cplook.datepicker.launch_timepicker
  handleScheduleButton('day')

handleScheduleButton = (button)->
  scheduled_email.handleScheduleButton(
    '#email_schedule_date_input',
    '#email_schedule_time_input',
    button
  )

handleFileReader = (app, id)->
  el = document.getElementById(id)
  if (el.files.length)
    reader = new FileReader()
    file = el.files[0]
    reader.onload = (ev)->
      app.ports.emailMsg.send(["FileResult", id, file.name, ev.target.result])
    reader.readAsDataURL(file)

handleEscape = (e)->
  app = this
  if e.keyCode == 27
    app.ports.emailMsg.send(["Cancel", ""])

handleDone = (app, val)->
  $(window).scrollTop($('#email_form_component').data('scrollpos'))
  $(document).unbind("keyup", handleEscape)
  app.ports.emailMsg.send(["EditorCleared", val])

handleResponse = (opts)->
  cmd = opts[0]
  data = opts[1]
  app = this
  if cmd == 'success' || cmd == 'cancel'
    handleCallbacks(cmd)
  else if cmd == 'setBody'
    window.requestAnimationFrame ->
      handleSetBody(data)
  else if cmd == 'setFields'
    handleSetFields(data)
  else if cmd == 'sendFields'
    handleSendFields(app)
  else if cmd == 'clearEditor'
    handleClearEditor(app, data)
  else if cmd == 'resetEditor'
    handleResetEditor(app, data)
  else if cmd == 'scheduleEnabled'
    handleScheduleEnabled(app)
  else if cmd == 'scheduleButton'
    handleScheduleButton(data)
  else if cmd == 'fileReader'
    handleFileReader(app, data)
  else if cmd == 'snackbar'
    snackbar(data)
  else if cmd == 'refreshApp'
    $("#app-#{data}").trigger('reload')
  else if cmd == 'openModal'
    return if retry "##{data}", ->
      handleResponse(opts)
    $("##{data}").modal({backdrop: 'static'})
  else if cmd == 'closeModal'
    $("##{data}").modal('hide')
    handleDone(app, "finished")

$ ->
  if $('#email_form_component').length > 0
    app = elm.EmailMain.embed(
      $('#email_form_component').get()[0], $('#email_form_component').data('flags')
    )
    app.ports.emailResponse.subscribe handleResponse.bind(app)
    window.email_modal = (opts)->
      $('#email_form_component').data('success_callback', opts.success_callback)
      $('#email_form_component').data('cancel_callback', opts.cancel_callback)
      $('#email_form_component').data('scrollpos', $(window).scrollTop())
      embedded = $('#email_form_component').data('flags').embedded
      $(document).keyup(handleEscape.bind(app)) unless embedded
      app.ports.email.send(opts)
      $(window).scrollTop(0) unless embedded

    $(document).on 'click', 'a.send-email', ->
      theLink = $(this)
      opts = {}
      addField = (field)->
        val = theLink.data(field)
        opts[field] = val if val?
      fields = [
        'to', 'event', 'subject', 'body', 'location', 'include_signature', 'templates'
      ]
      addField field for field in fields
      $('#email_form_component').data('origin', theLink.attr('id'))
      window.email_modal opts
      false

# SETS TEMPORARY VALUE ON USER FOR TRACKING PURPOSES IF SIGNATURE UPDATE WAS
# INITIATED FROM EMAIL MODAL
$(->
  if window.location.hash == '#email_settings'
    $('#user_email_anchor').val(1)
)
